import { cx } from '@linaria/core';
import { forwardRef } from 'react';
import { toggle, checkedModifier } from './switch.styles.js';
import { jsx } from 'react/jsx-runtime';

const Switch = /*#__PURE__*/forwardRef(function Switch(props, ref) {
  return /*#__PURE__*/jsx("input", {
    ...props,
    ref: ref,
    type: "checkbox",
    className: cx(toggle, props.className, props.checked && checkedModifier)
  });
});

export { Switch };
//# sourceMappingURL=switch.js.map
